import styled from 'styled-components';
import { SkapaTheme } from '@inter-ikea-kompis/themes';

export const Header = styled.div`
	display: flex;
	width: calc(100% - 32px);
	background-color: ${SkapaTheme.color.neutral.white};
	border-bottom: 1px solid ${SkapaTheme.color.border.light};
	padding: 16px;
`;

export const HeaderContainer = styled.div`
	width: 100px;
`;
